require('!!raw-loader!/builds/859119/v2/src/index.html');